export default function LoadingComp() {
  return (
    <span className="spinner is-elastic h-5 w-5 animate-spin rounded-full border-[3px] border-primary/30 border-r-primary dark:border-navy-500 dark:border-r-navy-300" />
  );
}
